import {
   OPEN_COMPONENT_PROPS_PANEL,
   HIDE_COMPONENT_PROPS_PANEL,
   EXPAND_COMPONENT_PROPS_PANEL,
   COLLAPSE_COMPONENT_PROPS_PANEL,
   OPEN_COMPONENT_PROPS_CONFIRMATION_DIALOG,
   CLOSE_COMPONENT_PROPS_CONFIRMATION_DIALOG,
   SET_COMPONENT_PROPS_PANEL_FORM_ISDIRTY,
   SET_SELECTED_COMPONENT_PROPS_PANEL,
   SET_SELECTED_NODE,
   SET_CURRENT_ACTION_FORM,
   OPEN_START_NODE_PANEL,
   HIDE_START_NODE_PANEL,
   SET_MODEL_LAYOUT,
   SET_TO_OPEN_NODE_TAB,
   SET_COMPONENT_PROPS_PANEL_TITLE,
   UPDATE_COMPONENT_PROPS_TAB,
   SET_RECENTLY_DELETED_BRANCH_NODE_ID
} from "redux/constants/flowDesigner";

const initialState = {
   showComponentPropsPanel: false,
   collapsed: false,
   componentPropsPanelTitle: "",
   selectedNode: {},
   flowElement: null,
   updateFlowElementCallback: null,
   showComponentPropsConfirmationDialog: false,
   isDirty: false, //when the code component editor value changes
   selectedComponentPropsPanel: null,
   previousSelectedNodeId: "",
   currentActionForm: null,
   showStartNodePanel: false,
   layoutModel: null,
   tabs: {},
   lastOpenedTabId: null,
   toOpenNodeTab: null,
   recentlyDeletedBranchNodeId: null
};

const componentPropsPanel = (state = initialState, { type, payload }) => {
   switch (type) {
      case OPEN_COMPONENT_PROPS_PANEL: {
         const { tabId, title, selectedNode, flowElement, updateFlowElementCallback } = payload;
         return {
            ...state,
            lastOpenedTabId: tabId,
            showComponentPropsPanel: true,
            componentPropsPanelTitle: title,
            selectedNode,
            flowElement,
            previousSelectedNodeId: selectedNode?.elementId,
            tabs: {
               ...state.tabs,
               [tabId]: {
                  showComponentPropsPanel: true,
                  componentPropsPanelTitle: title,
                  selectedNode,
                  flowElement,
                  updateFlowElementCallback,
                  collapsed: false,
                  isDirty: false,
                  previousSelectedNodeId: selectedNode?.elementId
               }
            }
         };
      }
      case HIDE_COMPONENT_PROPS_PANEL:
         if (!payload || !payload.tabId) {
            return state;
         }
         return {
            ...state,
            tabs: {
               ...state.tabs,
               [payload.tabId]: {
                  ...state.tabs[payload.tabId],
                  showComponentPropsPanel: false
               }
            }
         };
      case EXPAND_COMPONENT_PROPS_PANEL:
         return {
            ...state,
            collapsed: false,
            showComponentPropsPanel: true
         };
      case COLLAPSE_COMPONENT_PROPS_PANEL:
         return {
            ...state,
            collapsed: true,
            showComponentPropsPanel: false
         };
      case OPEN_COMPONENT_PROPS_CONFIRMATION_DIALOG:
         return {
            ...state,
            showComponentPropsConfirmationDialog: true
         };
      case CLOSE_COMPONENT_PROPS_CONFIRMATION_DIALOG:
         return {
            ...state,
            showComponentPropsConfirmationDialog: false
         };
      case SET_COMPONENT_PROPS_PANEL_FORM_ISDIRTY: {
         const { tabId, isDirty } = payload;
         if (!tabId) return state;

         return {
            ...state,
            tabs: {
               ...state.tabs,
               [tabId]: {
                  ...state.tabs[tabId],
                  isDirty
               }
            }
         };
      }
      case SET_SELECTED_COMPONENT_PROPS_PANEL:
         return {
            ...state,
            selectedComponentPropsPanel: payload
         };
      case SET_SELECTED_NODE:
         return {
            ...state,
            tabs: {
               ...state.tabs,
               [payload.tabId]: {
                  ...state.tabs[payload.tabId],
                  selectedNode: payload.node
               }
            }
         };
      case SET_CURRENT_ACTION_FORM:
         return {
            ...state,
            currentActionForm: payload
         };
      case OPEN_START_NODE_PANEL:
         return {
            ...state,
            showStartNodePanel: true
         };
      case HIDE_START_NODE_PANEL:
         return {
            ...state,
            showStartNodePanel: false
         };
      case SET_MODEL_LAYOUT:
         return {
            ...state,
            layoutModel: payload
         };
      case SET_TO_OPEN_NODE_TAB:
         return {
            ...state,
            toOpenNodeTab: payload
         };
      case SET_COMPONENT_PROPS_PANEL_TITLE: {
         const { tabId, title } = payload;
         if (!tabId) return state;

         return {
            ...state,
            tabs: {
               ...state.tabs,
               [tabId]: {
                  ...state.tabs[tabId],
                  componentPropsPanelTitle: title
               }
            }
         };
      }
      case UPDATE_COMPONENT_PROPS_TAB: {
         const tab = state.tabs[payload.tabId];

         if (!tab) return state;

         return {
            ...state,
            tabs: {
               ...state.tabs,
               [payload.tabId]: {
                  ...tab,
                  flowElement: payload.tabData
               }
            }
         };
      }
      case SET_RECENTLY_DELETED_BRANCH_NODE_ID: {
         return {
            ...state,
            recentlyDeletedBranchNodeId: payload.branchNodeId
         };
      }
      default:
         return state;
   }
};

export default componentPropsPanel;
